module.exports = __webpack_public_path__ + "img/no-records.738ef318.svg";